import { usePageSeo } from "@/hooks/usePageSeo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const TermsPage = () => {
  usePageSeo("terms");
  const { getSetting } = useSiteSettings();
  const company = getSetting("site_title", "World Transfers Punta Cana");
  const email = getSetting("email", "info@worldtransferspuntacana.com");

  return (
    <main className="min-h-screen bg-background">
      <section className="relative h-[40vh] flex items-end overflow-hidden bg-primary">
        <Navbar />
        <div className="container mx-auto px-4 relative z-10 pb-12 pt-24">
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-primary-foreground">Terms & Conditions</h1>
          <p className="text-primary-foreground/60 mt-2 font-sans">Last updated: March 9, 2026</p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-secondary" />
      </section>

      <section className="py-16 md:py-24 bg-background">
        <div className="container mx-auto px-4 max-w-3xl prose prose-neutral dark:prose-invert">
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using the services provided by {company}, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services.</p>

          <h2>2. Services</h2>
          <p>We provide private transportation and transfer services including airport transfers, hotel transfers, and group transportation in the Dominican Republic.</p>

          <h2>3. Bookings</h2>
          <ul>
            <li>All bookings are subject to availability.</li>
            <li>You must provide accurate pickup/drop-off details and contact information.</li>
            <li>A booking confirmation will be sent to your email address.</li>
            <li>You are responsible for being at the agreed pickup location on time.</li>
          </ul>

          <h2>4. Pricing & Payment</h2>
          <ul>
            <li>All prices are quoted in USD unless otherwise stated.</li>
            <li>Prices are based on the route, vehicle type, and number of passengers.</li>
            <li>Payment must be completed as per the selected payment method.</li>
            <li>Promotional codes are subject to their specific terms and expiration dates.</li>
          </ul>

          <h2>5. Cancellations & Refunds</h2>
          <ul>
            <li>Cancellations made 24+ hours before pickup: full refund.</li>
            <li>Cancellations made 12–24 hours before pickup: 50% refund.</li>
            <li>Cancellations made less than 12 hours before pickup: no refund.</li>
            <li>No-shows are non-refundable.</li>
          </ul>

          <h2>6. Passenger Responsibilities</h2>
          <ul>
            <li>Passengers must behave respectfully towards drivers and other passengers.</li>
            <li>Smoking, consumption of alcohol, and illegal substances are prohibited in all vehicles.</li>
            <li>Passengers are liable for any damage caused to the vehicle during the trip.</li>
          </ul>

          <h2>7. Liability</h2>
          <p>{company} shall not be liable for delays or cancellations caused by force majeure events, including but not limited to natural disasters, severe weather, road closures, or government actions.</p>
          <p>Our total liability for any claim arising from our services shall not exceed the total amount paid for the specific booking.</p>

          <h2>8. Modifications</h2>
          <p>We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of the updated terms.</p>

          <h2>9. Governing Law</h2>
          <p>These terms are governed by the laws of the Dominican Republic.</p>

          <h2>10. Contact</h2>
          <p>For questions regarding these terms, contact us at <a href={`mailto:${email}`} className="text-secondary hover:underline">{email}</a>.</p>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default TermsPage;
